import type { Component } from "solid-js";

export const ViewAllFeature: Component = () => {
	return (
		<button
			onClick={() => {
				document.getElementById("all_features")?.scrollIntoView({ behavior: "smooth" });
			}}
			type="button"
			class="header-20-semibold text-text-primary underline decoration-dotted"
			style={{
				"text-decoration-skip-ink": "none",
				"text-decoration-thickness": "12%",
				"text-underline-offset": "12.5%",
				"text-underline-position": "from-font"
			}}
		>
			View full AI tools & features
		</button>
	);
};
